<template>
  <div>
    <h1>Handling callback...</h1>
  </div>
</template>

<script setup>

</script>
